<template>
  <footer>
    <p>
      <span style="color: rgba(255, 255, 255, 0.6)">أ/ طارق عبدالغني عبدالباري</span>
      <span style="margin: 0 0.5rem; color: rgba(255, 255, 255, 0.2)">•</span>
      مدرس الرياضيات
    </p>

    <nav class="footer-legal" aria-label="روابط قانونية">
      <router-link to="/privacy-policy">سياسة الخصوصية</router-link>
      <span class="footer-legal-sep">•</span>
      <router-link to="/terms-of-service">شروط الاستخدام</router-link>
    </nav>

    <div class="d-flex align-items-center gap-3">
      <p>Powered by Ahmed Hawam &nbsp;⚡</p>
      <ul class="social">
        <li>
          <a
            href="https://facebook.com/ahmedhawam2030"
            target="_blank"
            aria-label="Facebook"
          >
            <i class="pi pi-facebook"></i>
          </a>
        </li>
        <li>
          <a
            href="https://wa.me/+201111488849"
            target="_blank"
            aria-label="WhatsApp"
          >
            <i class="pi pi-whatsapp"></i>
          </a>
        </li>
        <li>
          <a href="tel:01111488849" aria-label="Phone">
            <i class="pi pi-phone"></i>
          </a>
        </li>
      </ul>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
};
</script>

<style scoped>
.footer-legal {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  justify-content: center;
  font-family: 'Cairo', sans-serif;
  font-size: 0.85rem;
}
.footer-legal a {
  color: rgba(255, 255, 255, 0.72);
  text-decoration: none;
  font-weight: 700;
  transition: color 0.2s;
}
.footer-legal a:hover { color: #fff; }
.footer-legal-sep { color: rgba(255, 255, 255, 0.25); }
</style>
